import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=5d78bf24&scoped=true"
import script from "./productList.js?vue&type=script&lang=js&external"
export * from "./productList.js?vue&type=script&lang=js&external"
import style0 from "./productList.scss?vue&type=style&index=0&id=5d78bf24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78bf24",
  null
  
)

export default component.exports